import React, { FC, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ResultCard } from './styles'
import PATHS from '../../routes/paths'
import { Col, Row, Spin, Statistic, Typography } from 'antd'
import { IResultDetail } from '../../types/results'
import { modelApi, storageApi } from '../../api'
// import { Area, Bar, Cell, ComposedChart, ResponsiveContainer, YAxis } from 'recharts'
import { useTheme } from 'styled-components'
import { IRevenueEnriched } from '../../types/revenue'
import { RANGE_TYPES } from '../../constants'

type Props = {
  resultId: string
}

const RResultSummaryCard: FC<Props> = ({ resultId }) => {
  const theme = useTheme()
  const [isLoading, setIsLoading] = useState(true)
  const [result, setResult] = useState<IResultDetail>() // TODO: remove any
  const [revenues, setRevenues] = useState<IRevenueEnriched>([])

  async function fetchResult() {
    try {
      setIsLoading(true)
      const resultResponse = await storageApi.fetchResult(resultId)
      // await fetchRevenueData(resultResponse.revenueDataId)
      setResult(resultResponse)
      setIsLoading(false)
    } catch {
      setIsLoading(true)
    }
  }

  async function fetchRevenueData(dataId: string) {
    const startDate = '2020-01-01 00:00:00'
    const endDate = '2020-02-01 00:00:00'

    const revenueData = await modelApi.fetchRevenues({
      id: dataId,
      startDate,
      endDate,
      range: RANGE_TYPES.DAY,
    })
    const dateTimes = Object.keys(revenueData.revenueAncillary)
    const revenueAncillaries = Object.values(revenueData.revenueAncillary)
    const revenueEnergies = Object.values(revenueData.revenueEnergy)
    const profits = Object.values(revenueData.profit)
    const costs = Object.values(revenueData.cost)

    const enrichedRevenues = Object.values(dateTimes).map((datetime, idx) => ({
      datetime,
      revenueAncillary: revenueAncillaries[idx],
      revenueEnergy: revenueEnergies[idx],
      profit: profits[idx],
      profitAbs: Math.abs(profits[idx]),
      cost: costs[idx],
    })) as IRevenueEnriched

    setRevenues(enrichedRevenues)
  }

  useEffect(() => {
    if (resultId) {
      fetchResult()
    }
  }, [resultId])

  return (
    <Link to={PATHS.getResultDetailPath(resultId)}>
      <Spin spinning={isLoading}>
        <ResultCard className='mb-24 shadow'>
          <div className='p-24'>
            <Typography.Title className='d-inline primary mr-8' level={5}>
              Result
            </Typography.Title>
            <Typography.Title className='d-inline primary' level={3}>
              {result?.name}
            </Typography.Title>
          </div>

          {result && (
            <Row className='p-24' justify='space-around' gutter={[40, 40]}>
              <Col>
                <Statistic
                  title='Tot. Gen. Energy (MWh)'
                  value={result.totalGeneratedEnergyMwh}
                  precision={0}
                />
              </Col>
              <Col>
                <Statistic
                  title='Tot. Stored Energy (MWh)'
                  value={result.totalStoredEnergyMwh}
                  precision={0}
                />
              </Col>
              <Col>
                <Statistic
                  title='Total Revenue($)'
                  value={result.totalRevenueDollars}
                  precision={0}
                />
              </Col>
              <Col>
                <Statistic
                  title='Total Cycle Number'
                  value={result.totalCycleNumber}
                  precision={0}
                />
              </Col>
              <Col>
                <Statistic
                  title='Average Energy Cost($)'
                  value={result.averageEnergyCostDollars}
                  precision={0}
                />
              </Col>
              <Col>
                <Statistic
                  title='Average Energy Revenue($)'
                  value={result.averageEnergyRevenueDollars}
                  precision={0}
                />
              </Col>
            </Row>
          )}

          {/* <ResponsiveContainer width='100%' height={100}>
            <ComposedChart height={400} data={revenues}>
              <YAxis hide />
              <YAxis
                yAxisId='right'
                orientation='right'
                domain={[0, (dataMax: number) => dataMax * 5]}
                hide
              />
              <Area
                stackId='plus'
                type='monotone'
                dataKey='revenueAncillary'
                fill={theme.palettes.green[5]}
                stroke={theme.palettes.green[4]}
                strokeWidth={2}
              />
              <Area
                stackId='plus'
                type='monotone'
                dataKey='revenueEnergy'
                fill={theme.palettes.green[6]}
                stroke={theme.palettes.green[7]}
                strokeWidth={2}
              />
              <Area
                type='monotone'
                dataKey='cost'
                strokeDasharray='5'
                fillOpacity={0.1}
                fill={theme.palettes.red[4]}
                stroke={theme.palettes.red[5]}
                strokeWidth={2}
              />
              <Bar dataKey='profitAbs' yAxisId='right'>
                {revenues.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={entry.profit > 0 ? theme.palettes.green[3] : theme.palettes.red[3]}
                    stroke={entry.profit > 0 ? theme.colors.green : theme.colors.red}
                  />
                ))}
              </Bar>
            </ComposedChart>
          </ResponsiveContainer> */}
        </ResultCard>
      </Spin>
    </Link>
  )
}

export default RResultSummaryCard
